<template>
	<div
		class="chat__contact flex items-center pb-2"
		:class="{'bg-primary-gradient text-white shadow-lg': isActiveChatUser}"
	>
		<div class="contact__avatar mr-1">
			<vs-avatar class="border-2 border-solid border-white" :src="photoURL" size="42px" />
		</div>
		<div class="contact__container w-full flex items-center justify-between overflow-hidden">
			<div class="contact__info flex flex-col truncate w-4/5">
				<h5 class="truncate g-tools--description" :class="{'text-white': isActiveChatUser}">
					{{ resource.name }} {{ resource.lastname }}
				</h5>
				<span class="truncate title-resource">{{ resource.email }}</span>
			</div>

			<div class="chat__contact__meta flex self-start flex-col items-end w-1/5">
				<vs-button
					color="danger"
					class="mr-2"
					type="flat"
					icon-pack="feather"
					icon="icon-trash-2"
					@click="removeAssignedResource(resource.id)"
				></vs-button>
			</div>
		</div>
	</div>
</template>

<script>
import {downloadFileFromFirebase} from "@/helpers/firebaseDB.js";

import User from "@/models/User.js";
import firebase from "firebase/app";

export default {
	props: {
		resource: {type: Object, required: true},
		isActiveChatUser: {type: Boolean},
		removeAssignedResource: {type: Function},
	},
	data() {
		return {
			database: firebase.database(),
			avatar: "",
			total: 0,
			userSession: new User(),
		};
	},
	computed: {
		photoURL() {
			return this.avatar;
		},
	},
	methods: {
		getResourcePhoto() {
			const url = this.resource.img_url;
			if (!url) {
				return;
			}
			downloadFileFromFirebase(url)
				.then((res) => {
					this.avatar = res;
				})
				.catch((error) => {});
		},
	},
	mounted() {
		this.getResourcePhoto();
	},
	created() {},
};
</script>
<style lang="scss" scoped>
.title-resource {
	font-style: normal;
	font-weight: normal;
	font-size: 11px;
	line-height: 13px;
	color: #a3a3a3;
}
</style>
